// extracted by mini-css-extract-plugin
module.exports = {"container":"az_IOc","promptText":"az_JOc","promptLabel":"az_KOc","closeButton":"az_LOc","srOnly":"az_MOc"};